import { useTranslation } from "react-i18next"
import { alpha, Chip } from "@mui/material"
import { useTheme } from "@mui/material/styles"

import type { ChangeType } from "types/changelog.types"

interface ChangeTagProps {
  type: ChangeType
}

const ChangeTag = ({ type }: ChangeTagProps) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const config = {
    new: {
      label: t("changelog.NEW"),
      color: theme.palette.secondary.main,
    },
    fixed: {
      label: t("changelog.FIXED"),
      color: theme.palette.warning.main,
    },
    improved: {
      label: t("changelog.IMPROVED"),
      color: theme.palette.primary.main,
    },
  }

  const { label, color } = config[type]

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        width: "fit-content",
        backgroundColor: alpha(color, 0.1),
        color,
        border: `1px solid ${color}`,
        fontWeight: 600,
        fontSize: "0.7rem",
        height: 20,
        letterSpacing: "0.5px",
      }}
    />
  )
}

export default ChangeTag
